<script lang="ts" setup>
import DefaultFooter from '@/layouts/DefaultFooter.vue';
import DefaultHeader from '@/layouts/DefaultHeader.vue';
import DefaultMain from '@/layouts/DefaultMain.vue';
import { useHead } from '@unhead/vue';
import { useRoute } from 'vue-router';
import { getAlternateLink } from '@/plugins/router/localized.ts';
import { getCanonicalUrl } from '@/utilities';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';
import HeroSearch from '@/views/home/HeroSearch.vue';
import CookieConsent from '@/components/CookieConsent.vue';
import { computed, onMounted, ref } from 'vue';
import ProfileConfirmationBanner from '@/components/ProfileConfirmationBanner.vue';

const route = useRoute();

// --- Sync route <-> search store ---
useSearchFiltersStore();

const searchQueryParameters = [
  'searchLocationId',
  'searchLocationName',
  'searchLocationTypeLabel',
  'searchLocationKind',
  'location',
  'regionId',
  'cityId',
  'distance',
  'priceTypeId',
  'priceMin',
  'priceMax',
  'bedroomsMin',
  'bedroomsMax',
  'bathroomsMin',
  'bathroomsMax',
  'categoryIds',
  'page',
];

const isFilteredSearch = computed(() => route.name === 'search' && searchQueryParameters.some((parameter) => route.query[parameter] !== undefined));

useHead({
  meta: [() => (isFilteredSearch.value ? { name: 'robots', content: 'noindex, follow' } : undefined)],
  link: [
    () => {
      if (isFilteredSearch.value) {
        return undefined;
      }

      const alternateLink = getAlternateLink(route);
      return alternateLink ? { rel: 'alternate', ...alternateLink } : undefined;
    },
    () => ({ rel: 'canonical', href: getCanonicalUrl(isFilteredSearch.value ? route.fullPath : route.path) }),
  ],
});

const showCookieConsent = ref(false);
onMounted(() => {
  showCookieConsent.value = true;
});
</script>

<template>
  <DefaultHeader />
  <HeroSearch v-if="route.name === 'home'" />
  <DefaultMain>
    <ProfileConfirmationBanner />
    <RouterView />
  </DefaultMain>
  <DefaultFooter />
  <CookieConsent v-if="showCookieConsent" />
</template>

<style lang="css" scoped></style>
